import blueberryRaspberryLemon from "../assets/images/vape23/blueberryRaspberryLemon.webp";
import cranberryGrapes from "../assets/images/vape23/cranberryGrapes.webp";
import doubleApple from "../assets/images/vape23/doubleApple.webp";
import grapeLemon from "../assets/images/vape23/grapeLemon.webp";
import grapes from "../assets/images/vape23/grapes.webp";
import kiwiLemon from "../assets/images/vape23/kiwiLemon.webp";
import kiwiPassion from "../assets/images/vape23/kiwiPassion.webp";
import mangoPeach from "../assets/images/vape23/mangoPeach.webp";
import raspberryGrapefruit from "../assets/images/vape23/raspberryGrapefruit.webp";
import sourRaspberry from "../assets/images/vape23/sourRaspberry.webp";
import strawberryWatermelon from "../assets/images/vape23/strawberryWatermelon.webp";
import watermelonLime from "../assets/images/vape23/watermelonLime.webp";

const animations = ["swing-left", "swing-right", "float"];

export const products23 = [
  {
    id: 1,
    title: "Кислая малина",
    vape: sourRaspberry,
    bg: "#505E75",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 2,
    title: "Клюква Виноград",
    vape: cranberryGrapes,
    bg: "#B05460",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 3,
    title: "Черника Малина Лимон",
    vape: blueberryRaspberryLemon,
    bg: "#525F77",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 4,
    title: "Двойное яблоко",
    vape: doubleApple,
    bg: "#546378",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 5,
    title: "Виноград Лимон",
    vape: grapeLemon,
    bg: "#596781",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 6,
    title: "Виноград",
    vape: grapes,
    bg: "#B55763",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 7,
    title: "Киви Лимон",
    vape: kiwiLemon,
    bg: "#5E6D8A",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 8,
    title: "Киви Маракуйя Гуава",
    vape: kiwiPassion,
    bg: "#AA4F5C",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 9,
    title: "Манго Персик",
    vape: mangoPeach,
    bg: "#A94E5C",
    animation: animations[2 % animations.length], // float
  },
  {
    id: 10,
    title: "Малина Грейпфрут",
    vape: raspberryGrapefruit,
    bg: "#AF3854",
    animation: animations[0 % animations.length], // swing-left
  },
  {
    id: 11,
    title: "Клубника Арбуз",
    vape: strawberryWatermelon,
    bg: "#BC2E51",
    animation: animations[1 % animations.length], // swing-right
  },
  {
    id: 12,
    title: "Арбуз Лайм",
    vape: watermelonLime,
    bg: "#5F7CA5",
    animation: animations[2 % animations.length], // float
  },
];

export default products23;
